import { spacing } from './primitives'

export const spacingXXS = spacing[5]
export const spacingXS = spacing[10]
export const spacingS = spacing[15]
export const spacingM = spacing[20]
export const spacingL = spacing[30]
export const spacingXL = spacing[40]
export const spacingXXL = spacing[60]
export const spacingXXXL = spacing[80]

export const inkSpacingTokens = {
  spacingXXS,
  spacingXS,
  spacingS,
  spacingM,
  spacingL,
  spacingXL,
  spacingXXL,
  spacingXXXL,
} as const
